import React from "react";

const AuthBlocker = ({ tokenIsValid, msg }) => {
  if (tokenIsValid) {
    return null;
  }

  if (!msg) {
    msg = "Validando acceso...";
  }
  return (
    <div
      id="pantallaBloqueada"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(5px)"
      }}
    >
      <div
        id="mensaje"
        style={{
          position: "absolute",
          backgroundColor: "rgb(246, 194, 62)",
          borderRadius: "5px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
          padding: "20px",
          filter: "blur(0px)",
          color: "#fff",
          fontSize: "17px"
        }}
      >
        <p>{msg}</p>
      </div>
    </div>
  );
};

export default AuthBlocker;
